import { FiHeart } from "react-icons/fi";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
<footer className="footer footer-center p-6 bg-white/50 backdrop-blur-sm border-t border-navy-100 mt-auto">
      <div className="flex flex-col items-center gap-2">
        <p className="text-sm text-navy-600 flex items-center gap-1">
          <span className="font-medium text-navy-800">© {currentYear}</span>
          <span className="text-navy-400">•</span>
          <span className="text-navy-500">Mateoti Industries Ltd</span>
        </p>
        <div className="flex items-center gap-1 text-xs text-navy-400">
          <FiHeart className="w-3 h-3 text-accent animate-pulse" />
          <span>Built with</span>
          <span className="font-mono text-navy-600">React + Tailwind</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
